<template>
  <div class="ProgramActivityReminder-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="programActivityReminderData.isActive && isDeletePermission"
          @click="handleInactive(programActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!programActivityReminderData.isActive && isDeletePermission"
          @click="handleInactive(programActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isUpdatePermission"
          @click.stop="handleUpdate(programActivityReminderData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ProgramActivityReminder-view-page__body mb-6 mt-6">
        
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Id:</div>
                    <div>
                        {{ programActivityReminderData.id }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Code:</div>
                    <div>
                        {{ programActivityReminderData.code }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Trạng thái xóa:</div>
                    <div>
                        {{ programActivityReminderData.isDeleted ? "Đã bị xóa" : "Chưa bị xóa" }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">CreateDatetime:</div>
                    <div>
                        {{ convertTimestampToDate(programActivityReminderData.createDatetime, "DD/MM/YYYY HH:mm:ss") }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">UpdateDatetime:</div>
                    <div>
                        {{ convertTimestampToDate(programActivityReminderData.updateDatetime, "DD/MM/YYYY HH:mm:ss") }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">CreatorId:</div>
                    <div>
                        {{ programActivityReminderData.creatorId }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">UpdaterId:</div>
                    <div>
                        {{ programActivityReminderData.updaterId }}
                    </div>
            </b-col>
            <b-col>
                
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">ReminderTime:</div>
                    <div>
                        {{ programActivityReminderData.reminderTime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">ReminderAtDayNum:</div>
                    <div>
                        {{ programActivityReminderData.reminderAtDayNum }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">ReminderAtTime:</div>
                    <div>
                        {{ programActivityReminderData.reminderAtTime }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">ReminderContain:</div>
                    <div>
                        {{ programActivityReminderData.reminderContain }}
                    </div>
            </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      ProgramActivityReminderData: {},
    };
  },
  computed: {},
  methods: {
    returnPage() {
      this.$router.push({
        name: 'programActivityReminder_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'programActivityReminder_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadProgramActivityReminderData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin ProgramActivityReminder thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`ProgramActivityReminder`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadProgramActivityReminderData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramActivityReminder/${id}`);
        this.programActivityReminderData = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadProgramActivityReminderData();
  },
};
</script>
